<template>
  <div class="container">
    <a-card>
      <div class="header-section">
        <a-row type="flex" justify="space-between" align="middle" class="margin-bottom-20" :gutter="[16, 16]">
          <a-col :flex="auto">
            <h2 class="page-title">事件列表</h2>
          </a-col>
          <a-col :flex="none">
            <a-button type="primary" icon="plus" @click="handleAdd">新增事件</a-button>
          </a-col>
        </a-row>
      </div>

      <div class="search-form margin-bottom-20">
        <a-row :gutter="[16, 16]">
          <a-col :xxl="6" :xl="8" :lg="10" :md="24" :sm="24" :xs="24">
            <a-form-item class="search-form-item">
              <a-select v-model="searchForm.event_type_id" placeholder="请选择事件类型" allowClear style="width: 100%">
                <a-select-option v-for="type in eventTypes" :key="type.id" :value="type.id">
                  {{ type.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xxl="4" :xl="6" :lg="8" :md="12" :sm="24" :xs="24">
            <a-form-item class="search-form-item">
              <a-select v-model="searchForm.should_handle" placeholder="是否需要处理" allowClear style="width: 100%">
                <a-select-option :value="0">无需处理</a-select-option>
                <a-select-option :value="1">需处理</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xxl="4" :xl="6" :lg="8" :md="12" :sm="24" :xs="24">
            <a-form-item class="search-form-item">
              <a-select v-model="searchForm.status" placeholder="处理状态" allowClear style="width: 100%">
                <a-select-option :value="0">待处理</a-select-option>
                <a-select-option :value="1">待验收</a-select-option>
                <a-select-option :value="2">已完成</a-select-option>
                <a-select-option :value="3">已取消</a-select-option>
                <a-select-option :value="4">已驳回</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xxl="6" :xl="8" :lg="10" :md="24" :sm="24" :xs="24">
            <a-form-item class="search-form-item">
              <a-space class="search-buttons-wrapper">
                <a-button type="primary" @click="search" icon="search">查询</a-button>
                <a-button @click="resetSearch" icon="reload">重置</a-button>
              </a-space>
            </a-form-item>
          </a-col>
        </a-row>
      </div>

      <a-table 
        :dataSource="tableData" 
        :columns="columns" 
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
        :scroll="{ x: 'max-content' }"
        rowKey="id">
        <template slot="event_type" slot-scope="text, record">
          <a-tag :color="getEventTypeColor(record.event_type)">{{ text }}</a-tag>
        </template>
        <template slot="should_handle" slot-scope="text">
          <span :class="['status-tag', text === 1 ? 'status-tag-warning' : 'status-tag-muted']">
            {{ text === 1 ? '需处理' : '无需处理' }}
          </span>
        </template>
        <template slot="status" slot-scope="text, record">
          <span v-if="record.should_handle === 0" class="status-tag status-tag-muted">无需处理</span>
          <span v-else-if="text === 0" class="status-tag status-tag-pending">待处理</span>
          <span v-else-if="text === 1" class="status-tag status-tag-review">待验收</span>
          <span v-else-if="text === 2" class="status-tag status-tag-success">已完成</span>
          <span v-else-if="text === 3" class="status-tag status-tag-cancel">已取消</span>
          <span v-else-if="text === 4" class="status-tag status-tag-rejected">已驳回</span>
          <span v-else class="status-tag status-tag-muted">-</span>
        </template>
        <template slot="action" slot-scope="record">
          <a-button type="link" @click="handleDetail(record)">详情</a-button>
          <a-button type="link" @click="handleEdit(record)">编辑</a-button>
          <a-popconfirm
            title="确定要删除这条记录吗？"
            @confirm="handleDelete(record)"
          >
            <a-button type="link" style="color: red;">删除</a-button>
          </a-popconfirm>
        </template>
      </a-table>
    </a-card>

    <a-modal
      :title="modalTitle"
      :visible="modalVisible"
      :confirm-loading="modalConfirmLoading"
      @ok="submitForm"
      @cancel="handleModalCancel"
      :width="600"
    >
      <a-form :form="form" layout="vertical">
        <a-form-item label="事件类型">
          <a-select
            v-decorator="['event_type_id']"
            placeholder="请选择事件类型">
            <a-select-option v-for="type in availableEventTypes" :key="type.id" :value="type.id">
              {{ type.name }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="是否需要处理">
          <a-radio-group v-decorator="['should_handle', { initialValue: 0 }]">
            <a-radio :value="0">无需处理</a-radio>
            <a-radio :value="1">需处理</a-radio>
          </a-radio-group>
        </a-form-item>

        <a-form-item label="描述">
          <a-textarea
            v-decorator="['description']"
            placeholder="请输入描述"
            :rows="4" />
        </a-form-item>
      </a-form>
    </a-modal>

    <!-- 事件详情弹窗 -->
    <event-detail-modal 
      ref="eventDetailModal" 
      @review-complete="fetchData"
      @review-rejected="fetchData"
      @handle-created="fetchData" />
  </div>
</template>

<script>
import EventDetailModal from './components/eventDetailModal.vue'

export default {
  name: 'EventRecords',
  components: {
    EventDetailModal
  },
  data() {
    return {
      loading: false,
      modalVisible: false,
      modalConfirmLoading: false,
      modalType: 'add', // 'add' 或 'edit'
      currentRecord: null,
      tableData: [],
      eventTypes: [],
      availableEventTypes: [], // 可选择的事件类型（排除有eventable_type的）
      searchForm: {
        event_type_id: undefined,
        should_handle: undefined,
        status: undefined,
        user_id: ''
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true
      },
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          key: 'id',
          width: 70
        },
        {
          title: '事件类型',
          dataIndex: 'event_type.name',
          key: 'event_type',
          scopedSlots: { customRender: 'event_type' },
          width: 120
        },
        {
          title: '是否需要处理',
          dataIndex: 'should_handle',
          key: 'should_handle',
          scopedSlots: { customRender: 'should_handle' },
          width: 120
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          scopedSlots: { customRender: 'status' },
          width: 100
        },
        {
          title: '描述',
          dataIndex: 'description',
          key: 'description',
          ellipsis: true
        },
        {
          title: '创建时间',
          dataIndex: 'created_at',
          key: 'created_at',
          width: 170
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' },
          width: 180,
          fixed: 'right'
        }
      ]
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  computed: {
    modalTitle() {
      return this.modalType === 'add' ? '新增事件记录' : '编辑事件记录';
    }
  },
  created() {
    this.fetchData();
    this.fetchEventTypes();
  },
  methods: {
    // 获取事件类型列表
    async fetchEventTypes() {
      try {
        // 获取所有事件类型用于搜索
        const res = await this.$api.get_event_types({ page_no: 1, page_size: 100 });
        if (res.code === 200) {
          this.eventTypes = res.data.list || [];
        }
        
        // 获取可选择的事件类型（排除有eventable_type的）
        const availableRes = await this.$api.get_event_types_list({ exclude_eventable: true });
        if (availableRes.code === 200) {
          this.availableEventTypes = availableRes.data || [];
        }
      } catch (error) {
        console.error('获取事件类型失败:', error);
        this.$message.error('获取事件类型失败');
      }
    },

    // 根据事件类型获取颜色
    getEventTypeColor(eventType) {
      if (eventType && eventType.tag_color !== undefined) {
        const colorMap = ['blue', 'green', 'red', 'orange', 'purple'];
        return colorMap[parseInt(eventType.tag_color)] || 'default';
      }
      return 'default';
    },

    // 获取列表数据
    async fetchData() {
      this.loading = true;
      try {
        const params = {
          page_no: this.pagination.current,
          page_size: this.pagination.pageSize,
          ...this.searchForm
        };
        
        // 移除空值参数
        Object.keys(params).forEach(key => {
          if (params[key] === '' || params[key] === null || params[key] === undefined) {
            delete params[key];
          }
        });
        
        const res = await this.$api.get_event_records(params);
        if (res.code === 200) {
          this.tableData = res.data.list || [];
          // 修改分页字段适配
          this.pagination.current = parseInt(res.data.page.page_no);
          this.pagination.pageSize = parseInt(res.data.page.page_size);
          this.pagination.total = res.data.page.total;
        } else {
          this.$message.error(res.message || '获取事件记录列表失败');
        }
      } catch (error) {
        console.error('获取事件记录列表失败:', error);
        this.$message.error('获取事件记录列表失败');
      } finally {
        this.loading = false;
      }
    },

    // 查询
    search() {
      this.pagination.current = 1;
      this.fetchData();
    },

    // 重置搜索
    resetSearch() {
      this.searchForm = {
        event_type_id: undefined,
        should_handle: undefined,
        status: undefined,
        user_id: ''
      };
      this.pagination.current = 1;
      this.fetchData();
    },

    // 处理表格分页、排序等变化
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.fetchData();
    },

    // 新增
    handleAdd() {
      this.modalType = 'add';
      this.currentRecord = null;
      this.modalVisible = true;
      this.$nextTick(() => {
        this.form.resetFields();
      });
    },

    // 查看详情
    handleDetail(record) {
      this.$refs.eventDetailModal.open(record.id);
    },

    // 编辑
    handleEdit(record) {
      this.modalType = 'edit';
      this.currentRecord = { ...record };
      this.modalVisible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue({
          event_type_id: record.event_type_id,
          user_id: record.user_id,
          should_handle: record.should_handle !== undefined ? record.should_handle : 0,
          description: record.description
        });
      });
    },

    // 删除
    async handleDelete(record) {
      try {
        const res = await this.$api.delete_event_record(record.id);
        if (res.code === 200) {
          this.$message.success('删除成功');
          this.fetchData();
        } else {
          this.$message.error(res.message || '删除失败');
        }
      } catch (error) {
        console.error('删除失败:', error);
        this.$message.error('删除失败');
      }
    },

    // 提交表单
    submitForm() {
      this.form.validateFields(async (err, values) => {
        if (err) return;

        // 处理should_handle：如果选择需要处理，初始状态为待处理(0)
        if (values.should_handle === 1 && !values.status) {
          values.status = 0;
        } else if (values.should_handle === 0) {
          values.status = null;
        }

        this.modalConfirmLoading = true;
        try {
          let res;
          if (this.modalType === 'edit') {
            // 编辑
            res = await this.$api.update_event_record(this.currentRecord.id, values);
          } else {
            // 新增
            res = await this.$api.create_event_record(values);
          }

          if (res.code === 200) {
            this.$message.success(this.modalType === 'edit' ? '更新成功' : '新增成功');
            this.modalVisible = false;
            this.fetchData();
          } else {
            this.$message.error(res.message || (this.modalType === 'edit' ? '更新失败' : '新增失败'));
          }
        } catch (error) {
          console.error('操作失败:', error);
          this.$message.error(this.modalType === 'edit' ? '更新失败' : '新增失败');
        } finally {
          this.modalConfirmLoading = false;
        }
      });
    },

    // 关闭对话框
    handleModalCancel() {
      this.modalVisible = false;
      this.form.resetFields();
    }
  }
};
</script>

<style scoped>
.margin-bottom-20 {
  margin-bottom: 20px;
}

.page-title {
  margin: 0;
  font-size: 20px;
  font-weight: 500;
}

/* 状态标签样式 - 扁平化设计 */
.status-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 72px;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}

.status-tag-muted {
  background: #6b7280;
  color: #fff;
}

.status-tag-warning {
  background: #f59e0b;
  color: #fff;
}

.status-tag-pending {
  background: #3b82f6;
  color: #fff;
}

.status-tag-review {
  background: #8b5cf6;
  color: #fff;
}

.status-tag-success {
  background: #10b981;
  color: #fff;
}

.status-tag-cancel {
  background: #6b7280;
  color: #fff;
}

.status-tag-rejected {
  background: #ef4444;
  color: #fff;
}

/* 搜索表单样式 */
.search-form {
  background: #fafafa;
  padding: 16px;
  border-radius: 4px;
}

.search-form-item {
  margin-bottom: 0;
}

.search-buttons-wrapper {
  display: flex;
  width: 100%;
}

.form-tip {
  font-size: 12px;
  color: #999;
  margin-top: 5px;
}

/* 移动端优化 */
@media (max-width: 768px) {
  .page-title {
    font-size: 18px;
    margin-bottom: 0;
  }
  
  .header-section .ant-row {
    flex-direction: column;
    align-items: flex-start !important;
  }
  
  .header-section .ant-col {
    width: 100%;
  }
  
  .header-section .ant-btn {
    width: 100%;
    margin-top: 12px;
  }
  
  .search-form {
    padding: 12px;
  }
  
  .search-buttons-wrapper {
    width: 100%;
    gap: 8px;
  }
  
  .search-buttons-wrapper .ant-btn {
    flex: 1;
  }
}

/* Pad端和中等屏幕优化 (比手机宽，比PC窄) */
@media (min-width: 769px) and (max-width: 1199px) {
  .page-title {
    font-size: 19px;
  }
  
  .search-buttons-wrapper {
    width: 100%;
    gap: 8px;
  }
  
  .search-buttons-wrapper .ant-btn {
    flex: 1;
  }
}

/* PC端优化 (1200px以上) */
@media (min-width: 1200px) {
  .search-buttons-wrapper {
    gap: 8px;
    justify-content: flex-start;
  }
}

/* 表格响应式 */
:deep(.ant-table) {
  overflow-x: auto;
}

:deep(.ant-table-wrapper) {
  overflow-x: auto;
}

:deep(.ant-table-body) {
  overflow-x: auto;
}

/* 小屏幕下表格操作按钮 */
@media (max-width: 576px) {
  :deep(.ant-table-wrapper) {
    font-size: 14px;
  }
  
  :deep(.ant-btn-link) {
    padding: 0 4px;
  }
}

/* Modal响应式 */
@media (max-width: 768px) {
  :deep(.ant-modal) {
    max-width: calc(100vw - 32px);
    margin: 16px auto;
  }
}
</style>